export default __webpack_public_path__ + "static/media/i_service_medium_grey.c468dbd1.png";